import { LogLevel } from "./LogLevel";

export class Log
{
    date: Date;
    level: LogLevel;
    messages: any[];
    constructor(level: LogLevel, ...messages: any[])
    {
        this.date = new Date();
        this.level = level;
        this.messages = messages;
    }
}